import { useLanguage } from '../contexts/LanguageContext'

/**
 * Custom hook for accessing the translation function
 * @returns {function} Translation function t(key, fallback)
 */
export const useTranslation = () => {
  const { t } = useLanguage()
  
  // Ensure we always return a function
  if (typeof t !== 'function') {
    console.warn('Translation function not available, returning fallback function')
    return (key, fallback = '') => fallback || key
  }
  
  return t
}

/**
 * Custom hook for getting a specific translation
 * @param {string} key - Translation key (e.g., 'common.nav.home')
 * @param {string} fallback - Fallback text if translation not found
 * @returns {string} Translated text
 */
export const useTranslationText = (key, fallback = '') => {
  const { t } = useLanguage()
  return t(key, fallback)
}

/**
 * Hook for getting the current language
 * @returns {string} Current language code ('en' or 'pt')
 */
export const useCurrentLanguage = () => {
  const { language } = useLanguage()
  return language
}

/**
 * Hook for changing language
 * @returns {function} Function to change language
 */
export const useLanguageSwitcher = () => {
  const { changeLanguage } = useLanguage()
  return changeLanguage
}
